import { Errors, User } from '../shared/models';
import { UserService, ApiService } from '../shared/services';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';

/**
*  This class represents the lazy loaded LoginComponent.
*/

@Component({
  selector: 'app-login-cmp',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent {

  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private toastyService: ToastyService
  ) {
    const pureEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // use FormBuilder to create a form group
    this.authForm = this.formBuilder.group({
      'email': ['', Validators.compose([Validators.required, Validators.pattern(pureEmail)])],
      'password': ['', Validators.required]
    });
  }

  onLoggedin() {
    this.isSubmitting = true;
    this.errors = new Errors();

    const credentials = this.authForm.value;
    this.userService
      .attemptAuth(credentials)
      .subscribe(
        data => {
          this.userService.setAuth(data);
          //  this.router.navigateByUrl('/dashboard');
           this.router.navigate(['dashboard']);
        },
        err => {
          console.log(err)
          this.toastyService.error({
            title: 'Attention',
            msg: err.error.errors[0]['details'],
            showClose: true,
            timeout: 5000,
            theme: 'bootstrap',
          });
          this.isSubmitting = false;
        }
      );
  }
}

